import React from "react";
import { useEffect, useRef, useState, useCallback, useMemo } from "react";
import styles from "./CoupangAdBanner.module.css";

const CoupangAdBanner = ({ frameType = FrameType.SQUARE }) => {
  const coupangAdList = [
    {
      name: "브라운 물티슈(베베숲)",
      link: "https://link.coupang.com/a/cFi8fj",
      src: "https://coupa.ng/ci3gUY",
    },
    {
      name: "소화가 잘되는 우유(덴마크)",
      link: "https://link.coupang.com/a/cFjbjW",
      src: "https://coupa.ng/ci3g2I",
    },
    {
      name: "알러케어 어린이 비타민(차일드라이프)",
      link: "https://link.coupang.com/a/cFjdR6",
      src: "https://coupa.ng/ci3g68",
    },
    {
      name: "어린이 칼슘(차일드라이프)",
      link: "https://link.coupang.com/a/cFjga0",
      src: "https://coupa.ng/ci3hbZ",
    },
    {
      name: "주차타워(핑크퐁)",
      link: "https://link.coupang.com/a/cFjiUg",
      src: "https://coupa.ng/ci3hnO",
    },
  ];

  const getRandomAd = useCallback(() => {
    const time = new Date().getTime();
    const index = time % coupangAdList.length;
    return coupangAdList[index];
  }, []);

  const ad = useMemo(() => getRandomAd(), [getRandomAd]);
  return (
    <ResponsiveIframe
      ad={ad}
      aspectWidth={1}
      aspectHeight={2}
      frameType={frameType}
    ></ResponsiveIframe>
  );
};

export default CoupangAdBanner;

export const FrameType = Object.freeze({
  SQUARE: "SQUARE",
  RECTANGLE: "RECTANGLE",
});

export const MainAxis = Object.freeze({
  ROW: "ROW",
  COLUMN: "COLUMN",
});

const ResponsiveIframe = ({
  ad,
  aspectWidth = 1,
  aspectHeight = 1,
  mainAxis = MainAxis.COLUMN,
  frameType = FrameType.SQUARE,
}) => {
  // 1) wrapper div 참조
  const wrapperRef = useRef(null);

  // 2) 계산된 iframe 크기를 state로 저장
  const [size, setSize] = useState({ width: 0, height: 0 });

  // 3) 너비를 읽고 높이를 비율대로 계산하는 함수
  const calculateSize = () => {
    if (!wrapperRef.current) return;

    if (mainAxis === MainAxis.ROW) {
      // 가로 방향일 때는 wrapper의 실제 렌더링 너비(px)
      const width = wrapperRef.current.clientWidth;

      // height = width * (aspectHeight / aspectWidth)
      const height = Math.floor((width * aspectHeight) / aspectWidth);

      setSize({ width, height });
      return;
    } else if (mainAxis === MainAxis.COLUMN) {
      // wrapper의 실제 렌더링 너비(px)
      const wrapperWidth = wrapperRef.current.clientWidth;

      const height = wrapperWidth;
      const width = Math.floor(wrapperWidth * (aspectWidth / aspectHeight));

      setSize({ width, height });
      return;
    }
  };

  useEffect(() => {
    // 4) 컴포넌트 마운트 직후와 윈도우 리사이즈 시 계산
    calculateSize();
    window.addEventListener("resize", calculateSize);

    return () => {
      window.removeEventListener("resize", calculateSize);
    };
  }, []);

  return (
    <a
      ref={wrapperRef}
      className={
        frameType === FrameType.SQUARE
          ? styles.iframeSquareWrapper
          : styles.iframeRectangleWrapper
      }
      target="_blank"
      rel="noopener noreferrer"
      href={ad.link}
    >
      {/*
        5) 너비가 0(아직 계산 전)이 아니면 iframe 렌더링
        height, width 속성에 직접 숫자값을 넣습니다.
      */}
      {size.width > 0 && (
        <iframe
          className={styles.iframeSelf}
          src={ad.src}
          width={size.width}
          height={size.height}
          frameBorder="0"
          scrolling="no"
          referrerPolicy="unsafe-url"
          browsingtopics={true.toString()}
        />
      )}
    </a>
  );
};

export { ResponsiveIframe };
